(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('bonusTypesOverview', {
        templateUrl: 'views/components/views/bonusTypesOverview/bonusTypesOverview.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['translateService', 'modalService', function (translateService, modalService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            
            let translations = {
                tt_delete_grid_row_title: '',
                tt_delete_grid_row_warning: '',
                tt_delete_grid_row_confirm: '',
                tt_delete_grid_row_abort: ''
            };

            vm.gridReady = false;
  
            vm.grid = {
                dataTask: {
                    rememberId: 'w_bonustypeoverview.grid',              // Id used to retrieve user configs for the grid
                    loadData: {                                         // Method id of the get data procedure
                        method: 2623,
                        parameters: null
                    },
                    addRow: {                                           // 
                        method: null,
                        parameters: null,
                        pre: function () {
                            vm.grid.gridfunc.clearFilter();
                        }
                    },
                    removeRow: {                                        // 
                        method: null,
                        parameters: null
                    },
                    saveData: {
                        method: null,
                        parameters: null
                    }
                },
                translations: [],                                       // Comma separated list of words to be translated
                config: {                                               // TouchTime parameters configuring the grid
                    toolbar: {                                          // alternative -> toolbar: false,
                        hidden: false,                                  // If true, hides the toolbar, default is false
                        pdfExport: true,                                // Adds a predefined btn for exporting grid to pdf
                        excelExport: true,                              // Adds a predefined btn for exporting grid to excel
                        filter: true,                                   // Adds a predefined btn for en-/disabling filtering
                        columnVisibility: true,                         // Adds a predefined btn for deciding which columns to show/hide
                        headers: true,                                  // Adds a predefined btn for switched between db column names and titles
                        edit: false,                                    // Adds a predefined btn for en-/disabling editing in columns
                        add: false,                                     // Adds predefined btns for running an add function     // Needs addRow
                        delete: false,                                  // Adds a predefined btn for running a delete function  // Needs removeRow
                        save: false,                                    // Adds a predefined btn for running a save function    // Needs saveData
                        wrapping: true,                                 // Adds a predefined btn for en-/disabling wrapping of text in columns
                        layouts: true,                                  // Adds a predefined btn for adding, setting or removing predefined column layouts
                        buttons: [                                      // List of custom buttons
                            //{ name: 'updateBonusType', text: 'tt_update_bonus_type', func: function (data) { updateBonusType(data); }, icon: 'none', cssClass: 'btn btn-primary im-grid-btn-xs-r', translate: true, disabled: function () { return hasDirty(); } },
                        ]
                    },
                    fixedHeader: true,                                  // Enables header to stay visible when scrolling, 'limit' will trigger only headers, and not toolbar
                    keepSortOnAdd: false,                               // Clears sorting when adding a row
                    keepSortOnCheckbox: false,                          // Clears sorting on any clicked checkbox if false
                    keepSortOnIsSelected: false,                        // Clears sorting on only is_selected checkbox if false
                    rowClick: false,                                    // Enables functionality for drilldown on clicked row
                    specialFunc: {                                      // Adds additional functionality to the grid_functions column
                        newTab: false,                                  // If data has path, adds predefined "New tab"-button to functions
                        buttons: [
                            {
                                name: 'customEdit',
                                text: '',
                                icon: 'far-trash-alt',
                                type: 'danger',
                                func: function (data) {
                                    modalService.show({
                                        type: 'warning',
                                        title: translations.tt_delete_grid_row_title,
                                        message: translations.tt_delete_grid_row_warning,
                                        buttons: [{
                                            label: translations.tt_delete_grid_row_abort,
                                            cssClass: 'btn-warning',
                                            action: function (dialogItself) {
                                                dialogItself.close();
                                            }
                                        }, {
                                            label: translations.tt_delete_grid_row_confirm,
                                            cssClass: 'btn-danger',
                                            action: async function (dialogItself) {
                                                await vm.grid.gridfunc.removeRow(data);
                                                vm.grid.gridfunc.saveChanges(false);
                                                dialogItself.close();
                                            }
                                        }]
                                    });
                                }
                            }
                        ]
                    },
                    css: {
                        altColor: true,                                 // accepts -> true, false or hexbased color (i.e: '#A1B2C3')
                        textWrapping: false                             // Enables text-wrapping in columns, default is false
                    },
                    onDataSourceChanges: function (e) {                 // Triggers when changes happen to the dataSource
                        //console.log('onDataSourceChanges');
                        //console.dir(e);
                    }
                },
                kendo: {                                                // Kendo parameters configuring the grid
                    height: '100%',                                       // Sets the height of the grid component
                    aggregate: true,                                    // accepts -> true, false or list of objects (i.e: [{ field: 'amount_invval', aggregate: 'sum' } ])
                    selectable: false,                                  // accepts -> true, false, 'row', 'multiple' or 'multiple, row'
                    filterable: false                                   // Adds/Removes filter row, default is set to { mode: "row" }
                },
                optionfunc: null,                                       // Used for referencing functions in the current Component
                gridfunc: null                                          // Used for referencing functions in the Grid Component
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region ANGULAR FUNCTIONS

            vm.$onInit = function () {
                translate();

                vm.gridReady = true;
            }

            // #endregion ANGULAR FUNCTIONS

        }]
    });
})();
